import React from 'react';
import PostForm from '../components/posts/PostForm';
import PostList from '../components/posts/PostList';

function PostContainer() {
  return (
    <>
      <PostForm />
      <PostList />
    </>
  );
}

export default PostContainer;
